// class PagePopUpBtn {
//   constructor(btn) {
//     this.btn = btn;
//     this.pageUrl = this.btn.getAttribute("data-page-url");
//     this.init();
//   }

//   init() {
//     if (this.pageUrl) {
//       this.openPopup();
//     } else {
//       console.error("Missing data-page-url on PagePopUpBtn.");
//     }
//   }

//   getIframeUrl() {
//     const iframeUrl = new URL(
//       this.pageUrl,
//       window.location.origin
//     );

//     const currentParams = new URLSearchParams(
//       window.location.search
//     );

//     const previewThemeId =
//       currentParams.get("preview_theme_id");

//     if (previewThemeId) {
//       iframeUrl.searchParams.set(
//         "preview_theme_id",
//         previewThemeId
//       );
//     }

//     return iframeUrl.href;
//   }

//   openPopup() {
//     const popupOverlay =
//       document.createElement("section");

//     const iframeUrl = this.getIframeUrl();

//     popupOverlay.classList.add(
//       "page-popup--container"
//     );

//     popupOverlay.setAttribute(
//       "aria-hidden",
//       "false"
//     );

//     popupOverlay.innerHTML = `
//       <div class="inner--popup">
//         <button
//           type="button"
//           class="close-popup--btn"
//           aria-label="Close page popup"
//         >
//           <div
//             class="close-icon"
//             aria-hidden="true"
//           >
//             X
//           </div>

//           <div class="screen-reader-text">
//             Close Page Popup Button
//           </div>
//         </button>

//         <div class="page-popup-container">
//           <iframe
//             src="${iframeUrl}"
//             frameborder="0"
//             width="100%"
//             height="100%"
//             title="Page popup"
//             allowfullscreen
//           ></iframe>
//         </div>
//       </div>
//     `;

//     document.body.appendChild(popupOverlay);

//     this.addCloseEvent(popupOverlay);
//   }

//   addCloseEvent(popupOverlay) {
//     const closeBtn = popupOverlay.querySelector(
//       ".close-popup--btn"
//     );

//     if (!closeBtn) return;

//     closeBtn.addEventListener("click", () => {
//       popupOverlay.remove();
//     });
//   }
// }

class PagePopUpBtn {
  constructor(btn) {
    this.btn = btn;
    this.pageUrl = this.btn.getAttribute("data-page-url");

    this.isUnbookedPage = document.body.classList.contains(
      "page-unbooked-lash-and-brow-care"
    );

    this.popupOverlay = null;
    this.previousBodyOverflow = "";

    this.init();
  }

  init() {
    if (!this.pageUrl) {
      console.error("Missing data-page-url on PagePopUpBtn.");
      return;
    }

    if (this.isUnbookedPage) {
      this.openFetchedPopup();
    } else {
      this.openIframePopup();
    }
  }

  getPageUrl() {
    const pageUrl = new URL(
      this.pageUrl,
      window.location.origin
    );

    const currentParams = new URLSearchParams(
      window.location.search
    );

    const previewThemeId =
      currentParams.get("preview_theme_id");

    if (previewThemeId) {
      pageUrl.searchParams.set(
        "preview_theme_id",
        previewThemeId
      );
    }

    return pageUrl;
  }

  createPopup() {
    const existingPopup = document.querySelector(
      ".page-popup--container"
    );

    if (existingPopup) {
      existingPopup.remove();
    }

    this.popupOverlay =
      document.createElement("section");

    this.popupOverlay.className =
      "page-popup--container";

    this.popupOverlay.setAttribute(
      "role",
      "dialog"
    );

    this.popupOverlay.setAttribute(
      "aria-modal",
      "true"
    );

    this.popupOverlay.setAttribute(
      "aria-hidden",
      "false"
    );

    this.popupOverlay.innerHTML = `
      <div class="inner--popup">
        <button
          type="button"
          class="close-popup--btn"
          aria-label="Close page popup"
        >
          <span
            class="close-icon"
            aria-hidden="true"
          >
            X
          </span>

          <span class="screen-reader-text">
            Close Page Popup
          </span>
        </button>

        <div class="page-popup-container"></div>
      </div>
    `;

    document.body.appendChild(
      this.popupOverlay
    );

    this.previousBodyOverflow =
      document.body.style.overflow;

    document.body.style.overflow = "hidden";

    this.addCloseEvents();

    return this.popupOverlay.querySelector(
      ".page-popup-container"
    );
  }

  async openFetchedPopup() {
    const popupContent = this.createPopup();

    popupContent.innerHTML = `
      <div
        class="page-popup-loading"
        role="status"
      >
        Loading...
      </div>
    `;

    try {
      const pageUrl = this.getPageUrl();

      /*
       * Only allow content from the current
       * Shopify storefront.
       */
      if (pageUrl.origin !== window.location.origin) {
        throw new Error(
          "Popup URL must use the same storefront domain."
        );
      }

      const response = await fetch(pageUrl.href, {
        method: "GET",
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      if (!response.ok) {
        throw new Error(
          `Popup request failed: ${response.status}`
        );
      }

      const html = await response.text();

      const parsedDocument =
        new DOMParser().parseFromString(
          html,
          "text/html"
        );

      const pageContent =
        parsedDocument.querySelector("#MainContent") ||
        parsedDocument.querySelector("main");

      if (!pageContent) {
        throw new Error(
          "Main page content could not be found."
        );
      }

      /*
       * Remove scripts from the fetched page.
       * The current storefront already has
       * the theme JavaScript loaded.
       */
      pageContent
        .querySelectorAll("script")
        .forEach((script) => script.remove());

      popupContent.innerHTML = "";

      Array.from(pageContent.children).forEach(
        (child) => {
          popupContent.appendChild(
            document.importNode(child, true)
          );
        }
      );

      popupContent
        .querySelectorAll("a[href]")
        .forEach((link) => {
          const href = link.getAttribute("href");

          if (
            href &&
            !href.startsWith("#") &&
            !href.startsWith("javascript:")
          ) {
            link.setAttribute(
              "target",
              "_top"
            );
          }
        });

      window.dispatchEvent(
        new Event("resize")
      );
    } catch (error) {
      console.error(
        "Page popup failed to load:",
        error
      );

      popupContent.innerHTML = `
        <div class="page-popup-error">
          <p>
            We couldn't load this content.
          </p>

          <a
            class="button"
            href="${this.getPageUrl().href}"
          >
            View Page
          </a>
        </div>
      `;
    }
  }

  openIframePopup() {
    const popupContent = this.createPopup();
    const iframeUrl = this.getPageUrl();

    popupContent.innerHTML = `
      <iframe
        src="${iframeUrl.href}"
        frameborder="0"
        width="100%"
        height="100%"
        title="Page popup"
        allowfullscreen
      ></iframe>
    `;
  }

  addCloseEvents() {
    if (!this.popupOverlay) return;

    const closeBtn =
      this.popupOverlay.querySelector(
        ".close-popup--btn"
      );

    if (closeBtn) {
      closeBtn.addEventListener(
        "click",
        () => this.closePopup()
      );

      requestAnimationFrame(() => {
        closeBtn.focus();
      });
    }

    this.popupOverlay.addEventListener(
      "click",
      (event) => {
        if (event.target === this.popupOverlay) {
          this.closePopup();
        }
      }
    );

    this.handleEscape = (event) => {
      if (event.key === "Escape") {
        this.closePopup();
      }
    };

    document.addEventListener(
      "keydown",
      this.handleEscape
    );
  }

  closePopup() {
    if (this.popupOverlay) {
      this.popupOverlay.remove();
      this.popupOverlay = null;
    }

    document.body.style.overflow =
      this.previousBodyOverflow;

    document.removeEventListener(
      "keydown",
      this.handleEscape
    );

    if (this.btn) {
      this.btn.focus();
    }
  }
}

/*
 * Make the class globally accessible in case
 * any older theme code still references it.
 */
window.PagePopUpBtn = PagePopUpBtn;

/*
 * Delegated listener works for buttons added
 * by Shopify section rendering or the editor.
 */
if (!window.pagePopupListenerAdded) {
  window.pagePopupListenerAdded = true;

  document.addEventListener(
    "click",
    function (event) {
      const popupBtn = event.target.closest(
        ".__js--open-page-popup-btn"
      );

      if (!popupBtn) return;

      event.preventDefault();

      new PagePopUpBtn(popupBtn);
    }
  );
}